import { render } from "./MainNotification.vue?vue&type=template&id=2aadad62"
import script from "./MainNotification.vue?vue&type=script&lang=js"
export * from "./MainNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__